/* @flow */

export default class UpdateMobileRequest {
  mobile: string;
}
